import React, { useContext, useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import Header from "../Header/Header";
import { Spinner, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getAllNewsFeed } from "../../api/network";
import { toast } from "react-toastify";
import { toastWarning } from "../Common/ToastAlert";
import { formatDate } from "../../util/inputvalidations";
import EmptyScreen from "../Common/EmptyScreen";
import NoResultImage from "../../assets/images/no-result.svg";
import NoDataImage from "../../assets/images/no-added-data.svg";
import EditPencil from "../../assets/images/pencil.svg";
import DeleteIcon from "../../assets/images/delete.svg";
import LinkForward from "../../assets/images/link-forward.svg";
import ThumbIcon from "../../assets/images/feed-thumb.svg";
import PublishFeed from "./PublishFeed";
import DeleteFeed from "./DeleteFeed";
import { AdminContext } from "../../context/AdminContext";

const NewsFeedList = () => {
  const networkId = localStorage.getItem("networkId");
  const navigate = useNavigate();
  const { userPermissions } = useContext(AdminContext);

  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [isOpenPublishFeed, setIsOpenPublishFeed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [feed, setFeed] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchItem, setSearchItem] = useState("");
  const [selectedFeed, setSelectedFeed] = useState(null);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 8;

  const fetchNewsFeedData = async () => {
    try {
      setLoading(true);

      const feedCount = await getAllNewsFeed(networkId);
      const res = feedCount.data.result;
      setFeed(res);
      setFilteredData(res);
      setLoading(false);
    } catch (err) {
      setError(err);
      toast.warning(
        "Hmm. Something doesn't seem right. Try refreshing or logging in again.",
        toastWarning()
      );
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchNewsFeedData();
  }, []);

  // handle search
  const handleSearch = (query) => {
    setSearchItem(query);
    const filtered = feed.filter(
      (feed) =>
        feed.hashtag && feed.hashtag.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredData(filtered);
  };

  // No results content
  const noResultContent = {
    heading: "Sorry! No Results Found.",
    subHeading: [
      "We couldn’t find what you were looking for. Please try other ways.",
    ],
  };
  const noAddedContent = {
    heading: "No News Feed added yet",
    subHeading: ["Create a news feed for all the Updates"],
  };

  const sortedFeeds = filteredData.sort(
    (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
  );

  // Pagination
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = sortedFeeds?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil((sortedFeeds?.length || 0) / itemsPerPage);

  // --- HANDLE PAGE CHANGE ---
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % sortedFeeds.length;
    setItemOffset(newOffset);
  };

  // Reset to page 1 if search changes the total results
  useEffect(() => {
    setItemOffset(0);
  }, [sortedFeeds]);

  const handlePreview = (feed) => {
    const previewUrl = `https://nccbackend.staging.trustgrid.com/feed/renderNews/${feed.id}`;
    window.open(previewUrl, "_blank");
  };

  const handleOpenDeleteModal = (feed) => {
    setSelectedFeed(feed);
    setOpenDeleteModal(true);
  };

  const handleOpenPublishFeed = (feed) => {
    setSelectedFeed(feed);
    setIsOpenPublishFeed(true);
  };

  const navigateToEdit = (data) => {
    navigate("create-news-feed", { state: { data: data } });
  };

  return (
    <>
      {isOpenPublishFeed && (
        <PublishFeed
          show={isOpenPublishFeed}
          onHide={() => setIsOpenPublishFeed(false)}
          data={selectedFeed}
          setIsOpenPublishFeed={setIsOpenPublishFeed}
          refetchData={fetchNewsFeedData}
        />
      )}
      {openDeleteModal && (
        <DeleteFeed
          show={openDeleteModal}
          onHide={() => setOpenDeleteModal(false)}
          data={selectedFeed}
          setOpenDeleteModal={setOpenDeleteModal}
          refetchData={fetchNewsFeedData}
        />
      )}
      <div className="right-container">
        <div className="main-header">
          <Header title="News Feed" />
        </div>
        <div className="inner-body-container">
          {/* <ComingSoon /> */}
          <div className="requests-container">
            <div className="request-header">
              <div className="search-bar-box">
                <input
                  type="search"
                  className="search-bar"
                  placeholder="Search Tag"
                  id="search-text-box"
                  value={searchItem}
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </div>
              <div className="custom-select d-flex align-items-center">
                <div className="select-box">
                  <button
                    type="button"
                    className="dsm-btn-primary"
                    onClick={() => navigate("create-news-feed")}
                    disabled={
                      userPermissions?.some(
                        (userPermission) =>
                          userPermission.name === "NewsCreation"
                      )
                        ? false
                        : true
                    }
                  >
                    Create News Feed
                  </button>
                </div>
              </div>
            </div>
            <div className="requests-body">
              <Table borderless className="requests-table submit-proof-table">
                <thead>
                  <tr>
                    <th>Image</th>
                    <th>Title</th>
                    <th>Tags</th>
                    <th style={{ textAlign: "left" }}>Updated</th>
                    <th>Status</th>
                    <th style={{ textAlign: "center" }}>Preview</th>
                    <th style={{ textAlign: "right", paddingRight: 16 }}>
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr className="empty-screen-tr">
                      <td colSpan={7} rowSpan={8}>
                        <div className="mt-4 d-flex align-items-center justify-content-center">
                          <Spinner animation="border" variant="primary" />
                        </div>
                      </td>
                    </tr>
                  ) : feed?.length === 0 ? (
                    <tr className="empty-screen-tr">
                      <td colSpan={7}>
                        <EmptyScreen
                          content={noAddedContent}
                          emptyScreenImage={NoDataImage}
                        />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {sortedFeeds?.length === 0 ? (
                        <tr className="empty-screen-tr">
                          <td colSpan={7}>
                            <EmptyScreen
                              content={noResultContent}
                              emptyScreenImage={NoResultImage}
                            />
                          </td>
                        </tr>
                      ) : (
                        currentItems?.map((feed) => (
                          <tr key={feed?.id}>
                            <td className="feed-thumb">
                              <img
                                src={feed?.image || ThumbIcon}
                                height={40}
                                width={40}
                              />
                            </td>
                            <td className="ellipsis-text">
                              <b>{feed?.title}</b>
                            </td>
                            <td>
                              <sapn className="muted-badge">
                                {feed?.hashtag}
                              </sapn>
                            </td>
                            <td style={{ textAlign: "left" }}>
                              {formatDate(feed?.updatedAt)}
                            </td>
                            <td>
                              {feed?.active === true ? (
                                <sapn className="success-badge">Published</sapn>
                              ) : (
                                <button
                                  type="button"
                                  className="btn-sm dsm-btn-primary icon-btn"
                                  onClick={() => handleOpenPublishFeed(feed)}
                                  style={{ fontSize: 14 }}
                                  disabled={
                                    userPermissions?.some(
                                      (userPermission) =>
                                        userPermission.name === "NewsCreation"
                                    )
                                      ? false
                                      : true
                                  }
                                >
                                  Publish
                                </button>
                              )}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              <button
                                type="button"
                                className="btn-sm dsm-btn-secondary icon-btn"
                                onClick={() => handlePreview(feed)}
                              >
                                <img src={LinkForward} alt="icon" />
                              </button>
                            </td>
                            <td
                              style={{
                                textAlign: "right",
                                paddingRight: 16,
                                display: "flex",
                                justifyContent: "end",
                              }}
                            >
                              {!feed?.active === true && (
                                <button
                                  type="button"
                                  className="dsm-btn-secondary icon-btn mx-2"
                                  onClick={() => navigateToEdit(feed)}
                                  disabled={
                                    userPermissions?.some(
                                      (userPermission) =>
                                        userPermission.name === "NewsCreation"
                                    )
                                      ? false
                                      : true
                                  }
                                >
                                  <img src={EditPencil} alt="icon" />
                                </button>
                              )}
                              <button
                                type="button"
                                className="dsm-btn-danger-light icon-btn"
                                onClick={() => handleOpenDeleteModal(feed)}
                                disabled={
                                  userPermissions?.some(
                                    (userPermission) =>
                                      userPermission.name === "DeleteNews"
                                  )
                                    ? false
                                    : true
                                }
                              >
                                <img src={DeleteIcon} alt="icon" />
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </>
                  )}
                </tbody>
              </Table>
              {!loading && sortedFeeds?.length > itemsPerPage && (
                <div className="d-flex justify-content-end py-3">
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel="Next >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={3}
                    pageCount={pageCount}
                    previousLabel="< Prev"
                    renderOnZeroPageCount={null}
                    containerClassName="pagination mb-0"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    activeClassName="active"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewsFeedList;
